const BackgroundVisuals = () => {
  return (
    <div className="fixed inset-0 pointer-events-none -z-10 overflow-hidden bg-white">
      
      {/* Refined Brand Grid Overlay */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(#17091a 1px, transparent 1px),
            linear-gradient(90deg, #17091a 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      {/* Premium Brand Blobs - Magenta & Violet */}
      <div className="absolute top-[-10%] -left-20 w-[500px] h-[500px] bg-gradient-to-br from-[#952877]/10 to-[#592aa7]/5 rounded-full blur-[120px] animate-blob"></div>
      
      <div className="absolute top-[20%] -right-40 w-[600px] h-[600px] bg-gradient-to-bl from-[#592aa7]/8 to-[#17091a]/5 rounded-full blur-[140px] animate-blob animation-delay-2000"></div>
      
      <div className="absolute -bottom-40 left-[10%] w-[550px] h-[550px] bg-gradient-to-tr from-[#952877]/5 to-[#592aa7]/10 rounded-full blur-[120px] animate-blob animation-delay-4000"></div>
      
      {/* Floating Spark Elements - Theming the "Pings" */}
      <div className="absolute top-1/4 right-[15%] w-2 h-2 bg-[#952877]/30 rounded-full animate-ping"></div>
      <div className="absolute bottom-1/3 left-[20%] w-1.5 h-1.5 bg-[#592aa7]/40 rounded-full animate-ping animation-delay-1000"></div>
      <div className="absolute top-2/3 right-1/3 w-1 h-1 bg-[#17091a]/20 rounded-full animate-ping animation-delay-3000"></div>
      
      {/* Subtle Noise Texture Overlay (Optional for extra premium feel) */}
      <div className="absolute inset-0 opacity-[0.015] pointer-events-none brightness-100 contrast-150" 
        style={{ backgroundImage: `url("https://grainy-gradients.vercel.app/noise.svg")` }}>
      </div>
    </div>
  );
};

export default BackgroundVisuals;